(function () {
  'use strict';

  var selector = '.wb-jupiter';

  function setButtonState(form, state) {
    if (!form) return;

    var button = form.querySelector('[data-jupiter-add-button]');
    var text = form.querySelector('[data-jupiter-add-text]');

    if (!button || !text) return;

    var addLabel = button.getAttribute('data-add-label') || text.textContent || 'Ajouter';
    var loadingLabel = button.getAttribute('data-loading-label') || 'Ajout...';
    var addedLabel = button.getAttribute('data-added-label') || 'Ajouté';

    form.classList.remove('is-loading', 'is-added');

    if (state === 'loading') {
      form.classList.add('is-loading');
      button.disabled = true;
      text.textContent = loadingLabel;
      return;
    }

    if (state === 'added') {
      form.classList.add('is-added');
      button.disabled = false;
      text.textContent = addedLabel;

      window.setTimeout(function () {
        form.classList.remove('is-added');
        text.textContent = addLabel;
      }, 1200);

      return;
    }

    button.disabled = false;
    text.textContent = addLabel;
  }

  function showError(form, message) {
    if (!form) return;

    var error = form.querySelector('[data-jupiter-error]');
    if (!error) return;

    if (!message) {
      error.hidden = true;
      error.textContent = '';
      return;
    }

    error.hidden = false;
    error.textContent = message;
  }

  function openThemeCartDrawer() {
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
      return true;
    }

    var trigger = document.getElementById('CustomCartTrigger');
    if (trigger) {
      trigger.click();
      return true;
    }

    return false;
  }

  function dispatchCartEvents() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('wb:cart:updated'));
  }

  async function addVariantToCart(form) {
    var variantInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');

    if (!variantInput || !variantInput.value) {
      throw new Error('Variante introuvable.');
    }

    var variantId = Number(variantInput.value);
    var quantity = quantityInput && quantityInput.value ? Number(quantityInput.value) : 1;

    if (!variantId) {
      throw new Error('Variante invalide.');
    }

    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity || 1
          }
        ]
      })
    });

    var data = null;

    try {
      data = await response.json();
    } catch (e) {
      data = null;
    }

    if (!response.ok) {
      var message = data && data.description ? data.description : 'Impossible d’ajouter ce produit au panier.';
      throw new Error(message);
    }

    return data;
  }

  function bindVariantSelector(section) {
    var variantsWrapper = section.querySelector('[data-jupiter-variants]');

    if (!variantsWrapper || variantsWrapper.dataset.wbVariantReady === 'true') return;

    variantsWrapper.dataset.wbVariantReady = 'true';

    variantsWrapper.addEventListener('click', function (event) {
      var button = event.target.closest('.wb-jupiter__variant-opt');

      if (!button || button.disabled || button.classList.contains('is-disabled')) return;

      variantsWrapper.querySelectorAll('.wb-jupiter__variant-opt').forEach(function (item) {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');

      var variantInput = section.querySelector('[data-jupiter-variant-input]');
      var priceDisplay = section.querySelector('[data-jupiter-price]');

      if (variantInput && button.dataset.id) {
        variantInput.value = button.dataset.id;
      }

      if (priceDisplay && button.dataset.price) {
        priceDisplay.textContent = button.dataset.price;
      }

      showError(section.querySelector('[data-wb-jupiter-form]'), '');
    });
  }

  function bindAjaxForm(section) {
    var form = section.querySelector('[data-wb-jupiter-form]');

    if (!form || form.dataset.wbAjaxReady === 'true') return;

    form.dataset.wbAjaxReady = 'true';

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      showError(form, '');
      setButtonState(form, 'loading');

      try {
        await addVariantToCart(form);
        dispatchCartEvents();
        openThemeCartDrawer();
        setButtonState(form, 'added');
      } catch (error) {
        showError(form, error && error.message ? error.message : 'Impossible d’ajouter ce produit au panier.');
        setButtonState(form, 'idle');
      }
    });
  }

  function initJupiter(section) {
    if (!section) return;

    bindVariantSelector(section);
    bindAjaxForm(section);
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll(selector).forEach(initJupiter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();